<mat-toolbar role="banner" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-icon>drag_handle</mat-icon>
    <mat-icon-button>
        <mat-icon>tree</mat-icon>
    </mat-icon-button>
    <span class="sub-title">Editor</span>
    <mat-card-actions align='end'>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-actions>
</mat-toolbar>
<mat-card-content #editor cdkDropList [cdkDropListData]="fields" [cdkDropListConnectedTo]="boundLists"
    (cdkDragDropped)="drop($event)">
    <textarea title='{{recordName}}' cdkTextareaAutosize></textarea>
    <mat-chip-list>
        <!-- This section is new -->
        <mat-chip><mat-icon>storage</mat-icon>Data</mat-chip>
        <mat-chip><mat-icon>account_tree</mat-icon>Flow</mat-chip>
        <mat-chip><mat-icon>add</mat-icon>Add Page</mat-chip>
        <!-- this section is to drag (update) -->
        <mat-chip cdkDrag>
            <mat-icon>view_quilt</mat-icon>Form
        </mat-chip>
        <mat-chip cdkDrag>
            <mat-icon>table_chart</mat-icon>Table
        </mat-chip>
        <mat-chip cdkDrag>
            <mat-icon>bar_chart</mat-icon>Chart
        </mat-chip>
        <mat-chip cdkDrag>
            <mat-icon>menu</mat-icon>Navigation
        </mat-chip>
        <mat-chip cdkDrag>
            <mat-icon>work</mat-icon>Activity
        </mat-chip>
    </mat-chip-list>

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>Data Records</mat-panel-title>
                <mat-panel-description>Elements of data used to capture and display data</mat-panel-description>
            </mat-expansion-panel-header>
            <mat-card-actions align='end'>
                <button mat-mat-icon-button (click)="newRecord()"><mat-icon>add</mat-icon>New Record</button>
            </mat-card-actions>
            @for ( recDefn of recordDefinitions; track recDefn.name; ) {
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>{{recDefn.name}}</mat-panel-title>
                    <mat-panel-description class='sub-title'>{{recDefn.description }}</mat-panel-description>
                </mat-expansion-panel-header>
                <mat-chip-list>
                    @for (field of recDefn.fields ;track field.name) {
                    <mat-chip cdkDrag [cdkDragData]="{record:recDefn,field:field}">
                        {{field.title ?? field.name}}
                    </mat-chip>
                    }
                </mat-chip-list>
            </mat-expansion-panel>
            }
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>View Records</mat-panel-title>
                <mat-panel-description>Data combined into single records for easier display</mat-panel-description>
            </mat-expansion-panel-header>
            @for (recDefn of viewDefinitions; track recDefn.name ) {
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>{{recDefn.name}}</mat-panel-title>
                    <mat-panel-description class='sub-title'>{{recDefn.description }}</mat-panel-description>
                </mat-expansion-panel-header>
                <mat-chip-list>
                    @for( field of recDefn.fields; track field.name) {
                    <mat-chip [id]="recDefn.name+'.'+field.name" cdkDrag [cdkDragData]="{record:recDefn,field:field}">
                        {{field.title ?? field.name}}
                    </mat-chip>
                    }
                </mat-chip-list>
            </mat-expansion-panel>
            }
        </mat-expansion-panel>
    </mat-accordion>

</mat-card-content>